// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commutably {
  --small-font-size: 0.9em;
  --small-font-weight: lighter;
  --small-text-decoration: line-through;
  --small-color: var(--color-grey-3);
}
`, "",{"version":3,"sources":["webpack://./src/theme/components/Small.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,4BAA4B;EAC5B,qCAAqC;EACrC,kCAAkC;AACpC","sourcesContent":[".commutably {\n  --small-font-size: 0.9em;\n  --small-font-weight: lighter;\n  --small-text-decoration: line-through;\n  --small-color: var(--color-grey-3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
